import React from 'react'
import cx from 'classnames'
import { NavItem, OverlayTrigger, Tooltip } from 'react-bootstrap'
import { LinkContainer } from 'react-router-bootstrap'
import Brand from './Brand'

class Sidebar extends React.Component {
  constructor(...args) {
    super(...args)
    this.state = {
      collapse: true
    }
  }

  toggle = () => this.setState({ collapse: !this.state.collapse })

  tooltip = (name) => ( <Tooltip id={`tooltip-${name}`}>{name}</Tooltip> )

  getItem = (item, index) => (
    <LinkContainer key={index} to={item.alias} className='px-nav-item' activeClassName='active' exact>
      <NavItem eventKey={index}>
        <span className='px-nav-icon'><item.icon size={14}/></span>
        <span className='px-nav-label'>{item.name}</span>
      </NavItem>
    </LinkContainer>
  )

  renderItem = (apps) => {
    return apps.map( (item, index) => {
      if ('menu' in item && !item.menu) return null
      if (this.state.collapse) {
        return (
          <OverlayTrigger key={index} placement='right' overlay={this.tooltip(item.name)}>
            { this.getItem(item, index) }
          </OverlayTrigger>
        )
      } else {
        return this.getItem(item, index)
      }
    })
  }

  render() {
    if (this.props.history.location.pathname.indexOf('/login') !== -1) return null

    const { collapse } = this.state
    const navClass = cx('px-nav', 'px-nav-left', 'px-nav-animate', 'px-nav-fixed',
      { 'px-nav-collapse': collapse, 'px-nav-expand': !collapse }
    )

    return (
      <nav className={navClass} style={{backgroundImage: 'url(/images/solar-bg.png)', backgroundSize: 'cover'}}>
        <button type='button' className='px-nav-toggle' onClick={this.toggle}>
          <span className='px-nav-toggle-arrow' />
          <span className='navbar-toggle-icon' />
        </button>

        <div className='px-nav-scrollable-area' style={{ backgroundColor: 'rgba(0,0,0,0.65)'}}>
          <ul className='px-nav-content'>
            <Brand />
            {this.renderItem(this.props.apps.appls)}
          </ul>
        </div>
      </nav>
    )
  }
}

export default Sidebar



// WEBPACK FOOTER //
// ./src/components/nav/Sidebar.js